// ABOUTME: Arrow up icon component for move up/navigation actions
// ABOUTME: Supports className, size, and color customization

interface ArrowUpIconProps {
  className?: string
  size?: number
  color?: string
}

export const ArrowUpIcon = ({ className = "", size = 12, color = "currentColor" }: ArrowUpIconProps) => (
  <svg
    width={size}
    height={Math.round((size * 14) / 12)}
    viewBox="0 0 12 14"
    fill={color}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.0306 6.53016C10.9609 6.60008 10.8781 6.65556 10.787 6.69341C10.6958 6.73127 10.5981 6.75075 10.4993 6.75075C10.4006 6.75075 10.3029 6.73127 10.2117 6.69341C10.1206 6.65556 10.0378 6.60008 9.9681 6.53016L6.74997 3.31204V12.4995C6.74997 12.6984 6.67095 12.8892 6.5303 13.0299C6.38965 13.1705 6.19888 13.2495 5.99997 13.2495C5.80106 13.2495 5.61029 13.1705 5.46964 13.0299C5.32899 12.8892 5.24997 12.6984 5.24997 12.4995V3.31204L2.0306 6.53016C1.8897 6.67106 1.69861 6.75021 1.49935 6.75021C1.30009 6.75021 1.10899 6.67106 0.968098 6.53016C0.827202 6.38927 0.748047 6.19817 0.748047 5.99891C0.748047 5.79965 0.827202 5.60856 0.968098 5.46766L5.4681 0.967662C5.53778 0.897742 5.62057 0.842264 5.71173 0.80441C5.8029 0.766556 5.90064 0.74707 5.99935 0.74707C6.09806 0.74707 6.1958 0.766556 6.28696 0.80441C6.37813 0.842264 6.46092 0.897742 6.5306 0.967662L11.0306 5.46766C11.1005 5.53734 11.156 5.62013 11.1938 5.7113C11.2317 5.80246 11.2512 5.9002 11.2512 5.99891C11.2512 6.09762 11.2317 6.19536 11.1938 6.28653C11.156 6.37769 11.1005 6.46048 11.0306 6.53016Z" />
  </svg>
)
